import React from 'react';
import { FormFeedback, Input } from 'reactstrap';

export default function ReimbursementAmtElement({
  formMethods,
  name,
  rowData,
}) {
  const {
    formState: { errors },
  } = formMethods;
  return (
    <>
      <Input
        type="text"
        placeholder="Reimbursement Amount"
        className={`form-control external-filter-input ${errors?.[name] ? 'is-invalid' : ''}`}
        disabled
        value={rowData?.reimburAmt ?? 0}
        title="Reimbursement amount - auto filled"
      />
      {errors?.[name] && <FormFeedback>{errors?.[name]}</FormFeedback>}
    </>
  );
}
